
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UPDATE_NOTIFICATIONS from "@/apollo/notifications/UpdateNotifications.gql";

  import UIButton from "@/components/button/ui-button.vue";

  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";

  @Component({
    components: {
      UIButton,
    },
  })
  export default class MarkAllAsRead extends Vue {
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: Boolean, default: false }) readonly processing!: boolean;

    async markAllAsRead(): Promise<void> {
      this.$emit("update:processing", true);

      try {
        await this.$apollo.mutate({
          mutation: UPDATE_NOTIFICATIONS,
          variables: {
            _set: {
              read: true,
            },
            where: { user_id: { _eq: this.currentUserId } },
          },
        });
        this.$emit("completed");
      } catch (e) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
      } finally {
        this.$emit("update:processing", false);
      }
    }
  }
